import React from 'react';
import {Center, Flex, Link, Stack, useTheme} from '@chakra-ui/react';
import {Partner} from '../../../types/article';
import {TextA18, TextG12, TextG14} from '../../../components/typography';
import {BlueButton} from '../../../components/button';
import SwiperSlider from '../../../components/SwiperSlider';
import PlaceCard from '../../../components/Articles/PlaceCard';
import ArticleInfo from '../../../components/Articles/ArticleInfo';
import {BookmarkElement} from '../../../components/Articles';
import ExternalLink from '../../../components/ExternalLink';
import SignUpRequiredWrapper from '../../../components/SignupRequiredModal/SignupRequiredWrapper';
import {updatePartner} from "../../../endpoints/api";
import {InlineEditableField} from "../../../components/InlineEditableField";
import {ToastMessage} from "../../../components/toast";
import IconsHeader from "./IconsHeader";
import {EntityRole, useGetCurrentUserRoleForEntity} from "../../../hooks/useEntityUserRole";

const About = ({
  partner,
  refetchPartner,
  isPreview = false,
  setSignUpRequiredOpen,
}: {
  partner: Partner;
  refetchPartner: () => void;
  isPreview?: boolean;
  setSignUpRequiredOpen?: any;
}) => {
  const theme = useTheme();

  const { data: currentRole } = useGetCurrentUserRoleForEntity('partners', partner.id!);
  const canEditPartner = currentRole?.data === EntityRole.MANAGER || currentRole?.data === EntityRole.TEAM_MEMBER;

  return (
    <>
      <Stack gap=".25rem" textAlign="start" p="1rem">
        <IconsHeader
          partner={partner}
        />
        {partner.website && (
          <Center>
            <ExternalLink
              w="90%"
              href={partner.website}
              isExternal
              style={{textDecoration: 'none'}}>
              <BlueButton w="100%">
                <TextG14>Website</TextG14>
              </BlueButton>
            </ExternalLink>
          </Center>
        )}

        <Flex px="5%" pt="5%" flexDir="column" gap="10px" color={theme.colors.lightBlack}>
          <InlineEditableField
            value={partner?.description ?? ''}
            canEdit={canEditPartner}
            isMultiline={true}
            onSave={(description) => {
              updatePartner(partner.id!, { description }).then(() => refetchPartner()).catch(e => {
                ToastMessage({
                  status: 'error',
                  text: e.message
                });
              });
          }}
            renderDisplay={(value) => (
              <TextG12 dangerouslySetInnerHTML={{__html: value}}>{}</TextG12>
            )}
          />
          <InlineEditableField
            value={partner?.content ?? ''}
            canEdit={canEditPartner}
            isMultiline={true}
            onSave={(content) => {
              updatePartner(partner.id!, { content }).then(() => refetchPartner()).catch(e => {
                ToastMessage({
                  status: 'error',
                  text: e.message
                });
              });
            }}
            renderDisplay={(value) => (
              <TextG12 dangerouslySetInnerHTML={{__html: value}}>{}</TextG12>
            )}
          />
        </Flex>
        {partner.places && partner.places.length > 0 && (
          <>
            <SignUpRequiredWrapper setSignUpRequiredOpen={setSignUpRequiredOpen}>
              <TextA18>Visit This Partner</TextA18>
              <SwiperSlider
                items={partner.places}
                render={(item) => (
                  <PlaceCard
                    isPreview={isPreview}
                    place={item}
                    leftTopItem={<ArticleInfo article={item} />}
                    rightTopItem={isPreview ? null : <BookmarkElement article={item} />}
                  />
                )}
              />
            </SignUpRequiredWrapper>
          </>
        )}
      </Stack>
    </>
  );
};

export default About;
